import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5928be70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "作者：", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { getAppVoByIdUsingGet } from "@/api/appController";

import API from "@/api";
import { computed, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "../../constant/appEnum";
import dayjs from "dayjs";
import { useLoginUserStore } from "@/store/userStore";
import ShareTrigger from "@/components/trigger/ShareTrigger.vue";
import CommentCart from "@/components/list/CommentCart.vue";
import {
  doAppFavourUsingPost,
  doAppThumbUsingPost,
} from "@/request/api/appController";
import router from "@/router";

interface Props {
  id: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppDetailPage',
  props: {
    id: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const props = __props;

const data = ref<API.AppVO>({});
//查询登录用户
const loginUserStore = useLoginUserStore();
const loginUserId = loginUserStore.loginUser?.id;
const isMy = computed(() => {
  return loginUserId && loginUserId === data.value.userId;
});

const like = ref<boolean>(false);
const star = ref<boolean>(false);
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id) {
    return;
  }
  const response = await getAppVoByIdUsingGet({
    id: props.id,
  });
  if (response.data.code === 0 && response.data.data) {
    data.value = response.data.data;
    like.value = response.data.data?.isThumb;
    star.value = response.data.data?.isFavour;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});
/**
 * 答题
 */
const answer = () => router.push(`/answer/do/${props.id}`);

/**
 * 点赞
 */
const onLikeChange = () => {
  if (like.value) {
    data.value.thumbNum--;
  } else {
    data.value.thumbNum++;
    message.success("点赞成功");
  }
  like.value = !like.value;
  doAppThumbUsingPost({ bizId: props.id, bizType: "App" });
};

/**
 * 收藏
 */
const onStarChange = () => {
  if (star.value) {
    data.value.favourNum--;
  } else {
    data.value.favourNum++;
    message.success("收藏成功");
  }
  star.value = !star.value;
  doAppFavourUsingPost({ bizId: props.id, bizType: "App" });
};
const click = (url: string) => {
  router.push({ path: url });
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_IconEye = _resolveComponent("IconEye")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconStarFill = _resolveComponent("IconStarFill")!
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "appDetailCart" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              flex: "auto",
              class: "content"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", null, _toDisplayString(data.value.appName), 1),
                _createElementVNode("p", null, _toDisplayString(data.value.appDesc), 1),
                _createElementVNode("p", null, "应用类型：" + _toDisplayString(_unref(APP_TYPE_MAP)[data.value.appType]), 1),
                _createElementVNode("p", null, "评分策略：" + _toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[data.value.scoringStrategy]), 1),
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_a_avatar, {
                      "image-url": data.value.user?.userAvatar
                    }, null, 8, ["image-url"]),
                    _createVNode(_component_a_typography_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.value.user?.userName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, " 创建时间：" + _toDisplayString(_unref(dayjs)(data.value.createTime).format("YYYY-MM-DD HH:mm:ss")), 1),
                _createVNode(_component_a_space, {
                  size: "large",
                  style: {"width":"200px","font-size":"15px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconEye),
                        _createVNode(_component_a_typography_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.value.viewNum), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", { onClick: onLikeChange }, [
                          (like.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                _createVNode(_component_IconHeart)
                              ]))
                        ]),
                        _createVNode(_component_a_typography_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.value.thumbNum), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", { onClick: onStarChange }, [
                          (star.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createVNode(_component_IconStarFill, { style: {"color":"#fff35d"} })
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                _createVNode(_component_IconStar)
                              ]))
                        ]),
                        _createVNode(_component_a_typography_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.value.favourNum), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_7,
                _createVNode(_component_a_space, { size: "medium" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: answer
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("开始答题")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => [
                        _createVNode(ShareTrigger, {
                          "app-id": props.id
                        }, null, 8, ["app-id"])
                      ]),
                      _: 1
                    }),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "outline",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (click(`/add/app/${_ctx.id}`)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 修改应用 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "outline",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (click(`/add/question/${_ctx.id}`)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 设置题目 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (isMy.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          type: "outline",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (click(`/add/scoringResult/${_ctx.id}`)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("设置评分 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (isMy.value)
                  ? (_openBlock(), _createBlock(_component_a_steps, {
                      key: 0,
                      current: data.value.reviewStatus + 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_step, { description: "没审核也可以分享给小伙伴，但不能上架首页哦" }, {
                          default: _withCtx(() => [
                            _createTextVNode("创建成功 ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_step, { description: "等待管理员审核" }, {
                          default: _withCtx(() => [
                            _createTextVNode("待审核")
                          ]),
                          _: 1
                        }),
                        (data.value.reviewStatus != 2)
                          ? (_openBlock(), _createBlock(_component_a_step, {
                              key: 0,
                              description: data.value.reviewMessage
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("审核成功 ")
                              ]),
                              _: 1
                            }, 8, ["description"]))
                          : _createCommentVNode("", true),
                        (data.value.reviewStatus == 2)
                          ? (_openBlock(), _createBlock(_component_a_step, {
                              key: 1,
                              description: data.value.reviewMessage,
                              status: "error"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("审核失败 ")
                              ]),
                              _: 1
                            }, 8, ["description"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["current"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { flex: "320px" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  width: "100%",
                  src: data.value.appIcon,
                  style: {"margin":"50px 0"}
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(CommentCart, {
      "biz-id": props.id,
      "biz-type": "App",
      style: {"border":"1px solid rgba(128, 128, 128, 0.2)"}
    }, null, 8, ["biz-id"])
  ]))
}
}

})